import { render } from "./BsrValueWithGraph.vue?vue&type=template&id=57702560"
import script from "./BsrValueWithGraph.vue?vue&type=script&lang=js"
export * from "./BsrValueWithGraph.vue?vue&type=script&lang=js"

import "./BsrValueWithGraph.vue?vue&type=style&index=0&id=57702560&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__